// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'

import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'

import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import 'babel-polyfill'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileContract,faChartLine,faClipboardCheck ,faBox,faBoxes,faProcedures,faDoorOpen,faTabletAlt,faChargingStation,faPhoneVolume,faPlane,faCreditCard,faStore,faDoorClosed,faMoneyBillWave,faPeopleCarry,faToolbox,faPlus,faMoneyCheckAlt,faAmericanSignLanguageInterpreting,faFileInvoiceDollar,faUserCog,faUserPlus,faBoxOpen,faShippingFast,faDollarSign,faClipboardList,faCaretDown,faHistory, faDonate, faDolly,faCalculator, faUserTie, faChalkboardTeacher,faAddressCard, faLaptop,faCaretRight,faFax,faEnvelope,faPhone,faMapMarkerAlt, faTags,faArrowLeft ,faHotel ,faUtensils , faShoppingCart ,faCalendarAlt , faUserCircle , faUsers , faHandHoldingUsd ,faWrench ,faTicketAlt ,faCogs , faMobileAlt ,faDollyFlatbed} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch()

library.add( faFileContract,faChartLine,faClipboardCheck,faBox,faBoxes,faProcedures,faDoorOpen,faTabletAlt,faChargingStation,faPhoneVolume,faPlane,faCreditCard,faStore,faDoorClosed,faMoneyBillWave,faPeopleCarry,faToolbox,faPlus,faMoneyCheckAlt,faAmericanSignLanguageInterpreting,faFileInvoiceDollar,faUserCog,faUserPlus,faBoxOpen,faShippingFast,faDollarSign,fab,faClipboardList,faCaretDown,faHistory,faDonate,faDolly,faCalculator,faUserTie,faChalkboardTeacher,far,faAddressCard, faLaptop,faCaretRight,faFax,faEnvelope,faPhone,faMapMarkerAlt,faTags,faArrowLeft,faHotel,faUtensils ,faShoppingCart , faCalendarAlt ,faUserCircle ,faUsers,faHandHoldingUsd ,faWrench ,faTicketAlt ,faCogs ,faMobileAlt ,faDollyFlatbed)

import slickTop from '@/components/product/slick_top'
Vue.component('slick-top', slickTop)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('slick', Slick)
Vue.config.productionTip = true



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
})



// WEBPACK FOOTER //
// ./src/main.js